import { Card, CardContent, cn } from '@up2stay/up2promo-ui';
import type { ReactNode } from 'react';

/** Profiles SoT section title (`--t-h3`) for billing cards. */
export const BILLING_SECTION_TITLE_CLASS =
  'text-[15.5px] font-bold leading-tight text-foreground';

/** Profiles SoT body (`--t-body`). */
export const BILLING_SECTION_BODY_CLASS =
  'text-[13.5px] leading-relaxed text-foreground';

/** Profiles SoT muted body. */
export const BILLING_SECTION_MUTED_CLASS =
  'text-[13.5px] leading-relaxed text-muted-foreground';

/** Profiles SoT label (`--t-label`). */
export const BILLING_SECTION_LABEL_CLASS =
  'text-[11px] font-semibold uppercase tracking-[0.6px] text-muted-foreground';

type BillingSectionCardProps = {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
};

/**
 * Shared billing section shell — Card + Profiles density (`p-5 sm:p-6`).
 */
export function BillingSectionCard({
  children,
  className,
  contentClassName,
}: BillingSectionCardProps) {
  return (
    <Card className={cn('min-w-0 overflow-hidden', className)}>
      <CardContent
        className={cn('flex flex-col gap-5 p-5 sm:p-6', contentClassName)}
      >
        {children}
      </CardContent>
    </Card>
  );
}
